import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { triggerOnScroll, setPath, drawPath } from '../index'

function registerAnimations() {
    gsap.registerPlugin(ScrollTrigger)
    function init() {
        slideInAnim()
        fadeInAnim()
        heroDefaultAnim()
        cardsAnim()
        formAnim()
        bannerAnim()
        bannerKeyAnim()

        // PAGE ANIMATIONS
        healthPlansAnim()
        digitalHealthAnim()
        individualsAnim()

        // UNIQUE ANIMATIONS
        containerWithElementsSlideIn('.hp--features-wrp', '.ah--card')
        containerWithElementsSlideIn('.home--blog-grid', '.home--blog__card')
    }


    function slideInAnim() {
        let slideInContainers = document.querySelectorAll('.slide-in')
        slideInContainers.forEach(container => {
            let master = triggerOnScroll(container)
            master.from(container, { opacity: 0, y: '2em' })
        })
    }

    function fadeInAnim() {
        let fadeInContainers = document.querySelectorAll('.fade-in')
        fadeInContainers.forEach(container => {
            let master = triggerOnScroll(container)
            master.from(container, { opacity: 0 })
        })
    }

    function heroDefaultAnim() {
        let heros = document.querySelectorAll('.s-hero.default')
        heros.forEach(s => {
            let master = triggerOnScroll(s)
            let crumbs = s.querySelector('.breadcrumbs-wrp')
            let heading = s.querySelector('.s-hero__heading')
            let description = s.querySelector('.s-hero__p')
            let background = s.querySelector('.s-hero--bg-wrp')

            master
                .from(background, { opacity: 0, duration: 2, delay: 0.2 })
                .from(heading, { opacity: 0, y: '4em' }, '<+=25%')
                .from(description, { opacity: 0, y: '2em' }, '<+=35%')
                .from(crumbs, { opacity: 0 }, '<+=35%')
        })
    }

    function cardsAnim() {
        let cardsWrp = document.querySelectorAll('.ah--cards-grid')
        cardsWrp.forEach(container => {
            let master = triggerOnScroll(container)
            let heading = container.closest('section').querySelector('h2')
            let cards = container.querySelectorAll('.ah--card')

            master
                .from(heading, { opacity: 0, y: '1em' })
                .from(cards, { opacity: 0, y: '4em', stagger: 0.2 }, '<+=25%')
        })
    }

    function formAnim() {
        let gitForm = document.querySelector('.ah--form-cta--container')
        let master = triggerOnScroll(gitForm)

        master.from(gitForm, { opacity: 0, y: '4em' })
    }

    function bannerAnim() {
        let banners = document.querySelectorAll('.banner')
        banners.forEach(banner => {
            let heading = banner.querySelector('h2')
            let paragraph = banner.querySelector('p')
            let btn = banner.querySelector('a')
            let master = triggerOnScroll(banner)

            master.from(banner, { opacity: 0 })
                .from(heading, { opacity: 0 }, '<=+30%')
                .from(paragraph, { opacity: 0 }, '<=+30%')
                .from(btn, { opacity: 0 }, '<=+30%')
        })
    }

    function bannerKeyAnim() {
        let keys = document.querySelectorAll('.hp--banner__key')
        keys.forEach(key => {
            let banner = key.closest('.banner')
            let keyBody = key.querySelector('.key-body')
            let keyHole = key.querySelector('.key-hole')
            let master = triggerOnScroll(banner)
            setPath(keyBody)

            master
                .call(function () {
                    drawPath(keyBody, 2)
                })
                .from(keyHole, { opacity: 0, duration: 2 }, '+=1.5')

        })
    }

    /*

    PAGE ANIMATIONS

    */

    function healthPlansAnim() {
        let lines = document.querySelectorAll('.hp--struggle__line')
        lines.forEach(line => {
            let container = line.closest('.ah--cards-grid')
            let path = line.querySelector('path')
            let master = triggerOnScroll(container)
            setPath(path)

            master.call(function () {
                drawPath(path, 2)
            })
        })
    }


    function digitalHealthAnim() {
        questionsAnim()
        answersAnim()

        function questionsAnim() {
            let container = document.querySelectorAll('.dh--questions-wrp')
            container.forEach(container => {
                let master = triggerOnScroll(container)
                let cards = container.querySelectorAll('.dh--question-bubble--wrp')
                let cardsTimelines = []

                cards.forEach(card => {
                    let user = card.querySelector('.dh--question-bubble__user')
                    let bubble = card.querySelector('.dh--question-bubble')
                    let text = bubble.querySelector('div')
                    let tl = gsap.timeline({ defaults: { duration: 0.6 } })

                    tl
                        .from(user, { opacity: 0, yPercent: 50 })
                        .from(bubble, { opacity: 0 }, '<=50%')
                        .from(text, { opacity: 0 }, '<=50%')

                    cardsTimelines.push(tl)
                })

                cardsTimelines.forEach(timeline => {
                    master.add(timeline, '<=50%')
                })
            })
        }

        function answersAnim() {
            let container = document.querySelectorAll('.dh--answers--wrp')
            container.forEach(container => {
                let master = triggerOnScroll(container)
                let cards = container.querySelectorAll('.ah--card')

                let svgPath = container.querySelector('path')
                setPath(svgPath)

                master.call(function () {
                    drawPath(svgPath, 3)
                })
                    .from(cards, { opacity: 0, y: '2em', stagger: 0.3, delay: 0.4 }, '<')
            })
        }
    }

    function individualsAnim() {
        questinsAnim()
        answersAnim()

        function questinsAnim() {
            let container = document.querySelectorAll('.individuals--qa__wrp')
            container.forEach(container => {
                let master = triggerOnScroll(container)
                let pathWrp = container.querySelector('.individuals--qa__arrow')
                let path = {
                    line: pathWrp.querySelector('.line'),
                    arrow: pathWrp.querySelector('.arrow')
                }
                let h1 = container.querySelector('.individuals--qa__h1')
                let questions = container.querySelectorAll('.ah--li')
                let h2 = container.querySelector('.individuals--qa__h2')
                let p = container.querySelector('.individuals--qa__p')


                setPath(path.line)

                master
                    .from(h1, { opacity: 0, y: '2em' })
                    .from(questions, { opacity: 0, y: '2em', stagger: 0.2 }, '<=25%')
                    .call(function () { drawPath(path.line, 1) }, null, '<=75%')
                    .from(path.arrow, { opacity: 0, duration: 0.2 }, '<=0.95')
                    .from(h2, { opacity: 0, y: '2em' }, '<')
                    .from(p, { opacity: 0, y: '2em' }, '<=25%')
            })
        }

        function answersAnim() {
            let section = document.querySelectorAll('.individuals--qa__answers-sction')
            section.forEach(section => {
                let path = section.querySelector('.individuals--qa__answer-line path')

                let pathLength = path.getTotalLength()
                let pathOffset = pathLength

                path.style.strokeDasharray = pathLength
                path.style.strokeDashoffset = pathOffset

                path.style.transitionDuration = '0.8s'
                ScrollTrigger.create({
                    trigger: section,
                    start: 'top top+=10%',
                    end: 'bottom bottom-=25%',
                    scrub: 1,
                    onUpdate: function (tween) {
                        path.style.strokeDashoffset = `${pathOffset - pathLength * tween.progress}`
                    }
                })
            })

        }
    }


    /*

    UNIQUE ANIMATIONS

    */

    function containerWithElementsSlideIn(containerSelector, childrenSelector) {
        let container = document.querySelectorAll(containerSelector)
        container.forEach(container => {
            let elements = container.querySelectorAll(childrenSelector)
            let master = triggerOnScroll(container)
            master.from(elements, { opacity: 0, y: '2em', stagger: 0.2 })
        })
    }

    init()
}

export default registerAnimations